import type { ThemeOptions } from '@mui/material'

export const breakpoints: Partial<ThemeOptions['breakpoints']> = {
  values: {
    xs: 0,
    sm: 600,
    md: 720,
    lg: 1280,
    xl: 1920,
  },
}
